import { canonicalizePartnerRoute } from "@pandas/core-ui/route";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import LoadingDots from "@/components/LoadingDots";
import { useStore } from "@/store";
import { ensurePartnerConfig } from "@/utils/partnerConfig";
import { resolveLocationId } from "@/utils/resolveLocationId";
import { resolvePartnerFromSearch } from "@/utils/resolvePartnerFromSearch";
import { visionSearchParamsSchema } from "../../-search-params";

export const Route = createFileRoute("/$locale/$partner")({
	validateSearch: (search) => visionSearchParamsSchema.parse(search),
	beforeLoad: async ({ context, params, search, location }) => {
		const result = await canonicalizePartnerRoute({
			pathname: location.pathname,
			search,
			locale: params.locale,
			currentPartnerSegment: params.partner,
			reservedPartnerSegments: context.reservedPartnerRouteSegments,
			resolvePartner: resolvePartnerFromSearch,
			getStoredPartner: () => useStore.getState().instanceInfo?.partner.code,
		});

		if (result?.kind === "redirect") throw redirect({ href: result.href, replace: true });

		if (result?.kind === "unresolvable") {
			throw redirect({
				to: "/$locale/error",
				params: { locale: params.locale },
				search: { code: "partner_not_found" },
				replace: true,
			});
		}
	},
	loaderDeps: ({ search }) => ({ partnerCode: search.partnerCode, locationId: search.locationId }),
	loader: async ({ params, deps, context }) => {
		await ensurePartnerConfig(params.partner, resolveLocationId(deps.locationId, context.auth.user));
	},
	pendingComponent: () => <LoadingDots />,
	component: PartnerLayout,
});

function PartnerLayout() {
	return <Outlet />;
}
